import { useEffect, useState } from 'react'

import { useConfig } from '../../config'
import { ConsentCategory } from '../../consent'
import { useConsent } from '../../consent/core/consent.hooks'

const RedditPixel: React.FC = () => {
  const pixelId = useConfig('reddit.pixelId')
  const debug = useConfig<boolean>('analytics.debug') ?? false
  const advertisementConsent = useConsent(ConsentCategory.Advertisement)
  const [loaded, setLoaded] = useState(false)

  /**
   * load Reddit pixel script
   */
  const load = () => {
    if (debug) {
      console.log('[Reddit Pixel debug] Load script')
    }

    /* eslint-disable */
    ;(function (w: any, d: any, e: any, v: any) {
      if (w.rdt){ return }
      let p: any = (w.rdt = function () {
        p.sendEvent
          ? p.sendEvent.apply(p, arguments)
          : p.callQueue.push(arguments)
      })
      p.callQueue = []
      let t = d.createElement(e)
      t.src = v
      t.async = !0
      let s = d.getElementsByTagName(e)[0]
      s.parentNode.insertBefore(t, s)
    })(window, document, 'script', 'https://www.redditstatic.com/ads/pixel.js')
    /* eslint-enable */
    setLoaded(true)
  }

  /**
   * if permission is granted, load the script and initialize the pixel
   */
  useEffect(() => {
    if (loaded || !advertisementConsent || !pixelId) {
      return
    }

    load()

    const reddit = (window as any).rdt
    reddit('init', pixelId)

    if (debug) {
      console.log(`[Reddit Pixel debug] init ${pixelId}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loaded, advertisementConsent])

  /**
   * if permission is revoked, disable the pixel
   */
  useEffect(() => {
    if (!loaded || advertisementConsent) {
      return
    }
    const reddit = (window as any).rdt
    if (!reddit) {
      return
    }
    reddit('disableFirstPartyCookies')

    if (debug) {
      console.log('[Reddit Pixel debug] Revoke consent')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loaded, advertisementConsent])

  return null
}

export default RedditPixel
